import { gql } from '@apollo/client';

export const PRODUCTS_COLLECTION = gql`
  query CollectionProducts(
    $keyword: String
    $withCategory: Boolean! = false
    $withBrand: Boolean! = false
    $withPerfumeNote: Boolean! = false
    $withCollection: Boolean! = false
    $withTag: Boolean! = false
    $withSlug: ID! = ""
    $first: Int
    $after: String
    $onSale: Boolean = false
    $featured: Boolean = false
    $tagIn: [String]
    $categoryIn: [String]
    $brandIn: [String]
    $perfumeNoteIn: [String]
    $collectionIn: [String]
    $sort: [ProductsOrderbyInput] = [
      { field: MODIFIED, order: DESC }
      { field: SLUG, order: ASC }
    ]
  ) {
    productCategory(id: $withSlug, idType: SLUG) @include(if: $withCategory) {
      id
      name
      description
    }
    productBrand(id: $withSlug, idType: SLUG) @include(if: $withBrand) {
      id
      name
      description
    }
    productPerfumeNote(id: $withSlug, idType: SLUG)
      @include(if: $withPerfumeNote) {
      id
      name
      description
    }
    productCollection(id: $withSlug, idType: SLUG)
      @include(if: $withCollection) {
      id
      name
      description
    }
    productTag(id: $withSlug, idType: SLUG)
      @include(if: $withTag) {
      id
      name
      description
    }
    products(
      first: $first
      after: $after
      where: {
        search: $keyword
        orderby: $sort
        onSale: $onSale
        featured: $featured
        stockStatus: [IN_STOCK, ON_BACKORDER]
        taxonomyFilter: {
          filters: [
            { taxonomy: PRODUCTTAG, terms: $tagIn }
            { taxonomy: PRODUCTBRAND, terms: $brandIn }
            { taxonomy: PRODUCTPERFUMENOTE, terms: $perfumeNoteIn }
            { taxonomy: PRODUCTCOLLECTION, terms: $collectionIn }
            { taxonomy: PRODUCTCATEGORY, terms: $categoryIn }
          ]
          relation: AND
        }
      }
    ) {
      edges {
        cursor
        node {
          image {
            altText
            sourceUrl(size: LARGE)
            cloudinaryResource {
              public_id
              version
              url_suffix
              resource_type
              delivery_type
            }
          }
          id
          databaseId
          onSale
          name
          slug
          ... on VariableProduct {
            price(format: FORMATTED)
            regularPrice(format: FORMATTED)
            stockStatus
          }
          ... on SimpleProduct {
            price(format: FORMATTED)
            regularPrice(format: FORMATTED)
            stockStatus
          }
          type
          productBrands {
            nodes {
              count
              slug
              name
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        startCursor
      }
    }
  }
`;
